import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ProductShowcase } from "@/components/ProductShowcase";
import { SampleCard } from "@/components/SampleCard";
import { Configurator } from "@/components/Configurator";
import { InstallationQuote } from "@/components/InstallationQuote";
import { Specifications } from "@/components/Specifications";
import { TechnicalDocs } from "@/components/TechnicalDocs";
import { SeoContent } from "@/components/SeoContent";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";

export default function Home() {
  const scrollToConfig = () => {
    document.getElementById("configurateur")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main data-testid="home-page" className="bg-[#0a0a0a] text-[#f4ede0]">
      <Navbar onCartClick={scrollToConfig} />
      <Hero />
      <ProductShowcase />
      <SampleCard />
      <Configurator />
      <InstallationQuote />
      <Specifications />
      <TechnicalDocs />
      <SeoContent />
      <FAQ />
      <Footer />
    </main>
  );
}
